module.exports = __webpack_public_path__ + "img/3.564afb9e.png";